<template>
  <div class="my_mb_empty_tips">
    <div class="mb_empty_tips">
      <i class="empty_tips_img"></i>
      <div class="empty_tips_text">{{$t('components_my_mb_empty_tips_index_2367', [ tip ])}}</div>
    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'

export default {
  name: 'my_mb_empty_tips',
  props: {
    tip: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.my_mb_empty_tips {
  .mb_empty_tips {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 90px 0;
    .empty_tips_img {
      display: block;
      width: 157px;
      height: 123px;
      margin: 0 auto;
      background: url(~@/assets/image/default_icon.png) 0 0;
    }
    .empty_tips_text {
      margin-top: 28px;
      font-size: 16px;
      line-height: 24px;
      color: #333;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/my_mb_empty_tips/index.vue